<!-- 自提转快递 -->
<template>
  <el-dialog
    title="订单转换"
    :visible.sync="visible"
    width="600px"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" label-width="110px" :rules="rules">
      <el-form-item label="收件人姓名" prop="receiveUserName">
        <el-input
          type="text"
          placeholder="请输入收件人姓名"
          v-model="form.receiveUserName"
          style="width:300px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="收件人手机号" prop="receivePhone">
        <el-input
          type="text"
          placeholder="请输入收件人手机号"
          v-model="form.receivePhone"
          style="width:300px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="收件人地址" prop="receiveAddress">
        <el-input
          type="text"
          placeholder="请输入收件人地址"
          v-model="form.receiveAddress"
          style="width:300px;"
        ></el-input>
      </el-form-item>
      <el-row type="flex" justify="end" style="margin-top: 45px;">
        <el-button
          class="standard-button"
          style="margin-right: 10px;"
          @click="handleClose"
          >取消</el-button
        >
        <el-button
          class="standard-button"
          type="primary"
          :loading="loading"
          @click="handlerConfirm"
          >确认</el-button
        >
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: 'DeliveryDialog',
  data() {
    return {
      form: {
        receiveUserName: '',
        receivePhone: '',
        receiveAddress: '',
      },
      rules: {
        receiveUserName: [
          { required: true, message: '请输入收件人名称', trigger: 'blur' },
        ],
        receivePhone: [
          { required: true, message: '请输入收件人手机号', trigger: 'blur' },
        ],
        receiveAddress: [
          { required: true, message: '请输入收件人地址', trigger: 'blur' },
        ],
      },
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handlerConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.form);
        }
      });
    },
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    handleClose() {
      this.resetForm();
      this.$emit('update:visible', false);
    },
  },
};
</script>
